module.exports = __webpack_public_path__ + "img/resources-1440.d5ca1941.jpg";